// extracted by mini-css-extract-plugin
export var errorIcon = "_nb-1";
export var nameLogo = "_nb-0";